// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 562) return "static/chunks/562.ec6e2ace869d3930.js";
	if (chunkId === 203) return "static/chunks/203.f6474b468c85406a.js";
	if (chunkId === 296) return "static/chunks/ea88be26.708e47fd560a6f87.js";
	if (chunkId === 987) return "static/chunks/react-lottie.932b9eecaffb4c28.js";
	if (chunkId === 314) return "static/chunks/314.99304d4b55d14a02.js";
	if (chunkId === 661) return "static/chunks/661.56d3aacd9b11d7fc.js";
	if (chunkId === 548) return "static/chunks/548.a59b7b9d46634dee.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 222 ? "vendors.sravni" : chunkId) + "-" + {"109":"b53b88b2c94065ac","222":"8c344fc27f28ddad","347":"99680215e5f2c1f1","354":"28939ab7a14285b3","358":"e7b340126b5362bc","470":"50e6bbf4b193e010","707":"5194450b4871cc57","874":"8a0fc62edefd575a","893":"58ed2ecf7c5664f3"}[chunkId] + ".js";
};